import request from '../../../helpers/request';

const addTransport = async (values) => {
  const response = await request.post(
    `/HousingStock/transport`,
    values,
    `При привязки транспорта произошла ошибка`
  )

  return response
}

export default addTransport